import { Container, Box } from '@mui/material'
import React, { ReactNode } from 'react'

interface PageLayoutProps {
  children: ReactNode
}

const PageLayout = ({ children}: PageLayoutProps) => {
  return (
    <Container
      sx={{
        maxWidth: {xs:390, sm: 455, md:1000, lg: 1100, xl: 1450},
        mb: 4,
        px: { xs: 3, sm: 3 },
        py: 2,
        mx: {xs:3, sm:2, md:1, lg: 1, xl: 5.5},
      }}>
      <Box>{children}</Box>
    </Container>
  )
}

export default PageLayout
